var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        id: "recruiterReferralModal",
        maximized: _vm.maximized,
        value: _vm.recruiterReferralModal
      },
      on: {
        hide: function($event) {
          _vm.closeModal("recruiterReferral")
        }
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "q-toolbar-title",
                [
                  _c("q-icon", { attrs: { name: "fa fa-certificate" } }),
                  _vm._v(" Recruiter Referral Report\n    ")
                ],
                1
              ),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    _vm.closeModal("recruiterReferral")
                  }
                }
              })
            ],
            1
          ),
          _c("div", { staticStyle: { padding: "40px 20px" } }, [
            _c("div", { staticClass: "sl-row" }, [
              _c("div", { staticClass: "sl-col-12" }, [
                _c(
                  "p",
                  {
                    staticClass: "text-center",
                    staticStyle: { "max-width": "350px", margin: "0 auto" }
                  },
                  [
                    _vm._v(
                      "This report shows all the recruiters and their referrals for a given date range."
                    )
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "sl-row sl-vp" }, [
              _c(
                "div",
                { staticClass: "sl-col-6" },
                [
                  _c("q-datetime", {
                    attrs: {
                      "stack-label": "Start Date",
                      value: _vm.recruiterReferralForm.START_DATE
                    },
                    on: {
                      change: function(val) {
                        return _vm.changeState({
                          area: "recruiterReferralForm",
                          field: "START_DATE",
                          val: val
                        })
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sl-col-6" },
                [
                  _c("q-datetime", {
                    attrs: {
                      "stack-label": "End Date",
                      value: _vm.recruiterReferralForm.END_DATE
                    },
                    on: { change: _vm.endDateHandler }
                  })
                ],
                1
              )
            ])
          ]),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("q-toolbar-title"),
              _c("q-btn", {
                attrs: { color: "green", icon: "fa fa-gear", label: "Run" },
                nativeOn: {
                  click: function($event) {
                    _vm.runReport()
                  }
                }
              }),
              _vm._v(" \n      "),
              _c("q-btn", {
                attrs: { outline: "", color: "faded", label: "Cancel" },
                nativeOn: {
                  click: function($event) {
                    _vm.closeModal("recruiterReferral")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }